const toFolder = (data) => ({
  hidden: !!data.hidden,
  isFolder: true,
  ...data,
});

export default toFolder;
